import type { FaireProductEntity } from "../../entity_types/product";

export const p_cc2bs338gf: FaireProductEntity = {
  token: "p_cc2bs338gf",
  type: "product",
  name: "Gameday Basketball Charm Crystal Embellished Headband",
  brandToken: "b_vswk7rntc2",
  brandName: "SP Sophia Collection",
  imageUrl:
    "https://cdn.faire.com/fastly/4234db7aebdd9c837a523e71b44b708e10036a3a33aa0d490fb0966aeb64d4b8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5d41d2707b28abe2e48b36a531be8f62ff8bfb1dec903a301fc13e1daa4a2e3b.jpeg",
    "https://cdn.faire.com/fastly/d60a862de4600ab391e575e60ff609c7ef4fb2c2d8ade2e36df99b291f1e28b7.jpeg",
  ],
  priceDollars: 13.22,
  description:
    'Measurements:\nHeight: 6.5"\nWidth: 2.5"\n\nBring bold energy and spirited flair to your look with this Gameday Basketball Charm Top Knotted Headband. Designed with eye-catching crystal embellishments and sporty sew-on charms, this standout piece adds a fashionable twist to athletic-inspired style. Whether you\'re headed to the stadium, a watch party, or a tailgate, this headband delivers playful glam and game-ready appeal. A fan favorite for casual outings, school events, and weekend rallies, it’s the ultimate accessory for sports enthusiasts who love to show their team pride in style.',
  tags: [],
  msrpDollars: 52.88,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:16.939Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
